import styled from 'styled-components';
import squiggly from 'images/squiggly.png';
import { mediaMax } from 'themes/helpers';

export const StyledWrapper = styled.div`
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  bottom: unset;
  z-index: 10;

  .blue {
    width: 100%;
    background-color: #0239FF;
    text-align: center;

    > p {
      --squiggly-size: 38px;
      display: inline-block;
      text-align: center;
      font-size: 20px;
      padding: 4px;
      position: relative;
      font-weight: 300;
      font-family: 'Jost', sans-serif;

      > a {
        color: white;
        &:hover {
          text-decoration: underline;
        }
      }

      &:nth-of-type(2) {
        display: none;
      }

      &::before, 
      &::after {
        content: '';
        position: absolute;
        z-index: 1;
        width: var(--squiggly-size);
        height: var(--squiggly-size);
        top: 50%;
        transform: translateY(-50%);
        background: url(${squiggly}) no-repeat center/contain;
      }

      &::before {
        left: calc(var(--squiggly-size) * -1);
      }
      &::after {
        right: calc(var(--squiggly-size) * -1);
      }
      
      ${mediaMax.phoneL`
       font-size: 0.85rem;

       &:nth-of-type(1) {
        display: none;
        }

        &:nth-of-type(2) {
          display: inline-block;
        }
     `}
    }
  }

  .brands {
    position: absolute;
    bottom: -50px;
    left: 0;
    width: 100%;
    padding: 10px 4px;
    background-color: rgba(0, 0, 0, 0.3);
    text-align: center;

    > span {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 1rem;
      font-size: 1.25rem;
      
      img {
        height: 30px;
      }
    }
    ${mediaMax.phoneL`
      bottom: -40px;
      > span {
        font-size: 0.85rem;

        img {
          height: 20px;
        }
      }
    `}
  }
`;



// WEBPACK FOOTER //
// ./src/components/Nav/styles.js